import { NgClass, NgStyle } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { InfoComponent } from "@components/info/info.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { StringUtils } from "~app/common/utils/string-utils";
import { KilometerPipe } from "../../../../../common/pipes/kilometer.pipe";
import { ITplArbetsorderDetailMottagninsplats, ITplArbetsorderDetails, ITplJusteraruttArbetsorder } from "../../models/dtos";
import { TplService } from "../../services/tpl.service";
import { TplTransportavstandModalComponent } from "../tpl-transportavstand-modal/tpl-transportavstand-modal.component";
import { ITplArbetsorderListRow, TplArbetsorderListColumnType, TplArbetsorderListModel } from "./tpl-arbetsorder-list-model";

@Component({
    selector: "rask-tpl-arbetsorder-list",
    templateUrl: "./tpl-arbetsorder-list.component.html",
    styleUrls: ["./tpl-arbetsorder-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgStyle,
        NgClass,
        IconButtonComponent,
        InfoComponent,
        TranslatePipe,
        KilometerPipe
    ]
})
export class TplArbetsorderListComponent {
    @Input() arbetsorder: ITplArbetsorderDetails;
    @Input() canEdit: boolean;
    @Input() content: TplArbetsorderListModel;
    types = TplArbetsorderListColumnType;

    private readonly modalService = inject(NgbModal);
    private readonly tplService = inject(TplService);

    canDestinera(): boolean {
        return !this.tplService.isExternArbetsorder(this.arbetsorder);
    }

    editTransportavstand(transportavstand: any, row: ITplArbetsorderListRow) {
        const ao = {
            id: this.arbetsorder.id,
            beteckning: this.arbetsorder.beteckning,
            namn: this.arbetsorder.namn,
            raskVo: this.arbetsorder.raskVo,
            anvandVerkligaAvlagg: this.arbetsorder.anvandVerkligaAvlagg
        } as ITplJusteraruttArbetsorder;

        TplTransportavstandModalComponent.open(ao, row.handelssortimentId, transportavstand.mottagningsplatsId, false, "transportplanera", this.modalService);
    }

    toggleDetails(row: number) {
        this.content.rows[row].isDetailsOpen = !this.content.rows[row].isDetailsOpen;
    }

    writeMottagningsplats(value: ITplArbetsorderDetailMottagninsplats) {
        const res = `${value.mottagningsplatsnummer} ${value.namn}`;
        const maxLength = 25;

        if (!ObjectUtils.hasValue(value.foradlatHandelssortimentId)) {
            return res;
        }
        return StringUtils.suffixString(res, "//FLIS", maxLength);
    }
}
